import { useAuth } from '@/features/auth/authContext'

/** Which admin panel a session gets: head office's, a franchise partner's, or none. */
export type AdminArea = 'company' | 'franchise' | null

export function adminAreaOf(roleKey: string | undefined): AdminArea {
  if (roleKey === 'company_admin') return 'company'
  if (roleKey === 'franchise_partner') return 'franchise'
  return null
}

/**
 * Hides the entry; it does not replace handling the 403. The server decides,
 * and a role can change under a tab that has been open for hours.
 */
export function useAdminArea(): AdminArea {
  const { role } = useAuth()
  return adminAreaOf(role?.key)
}
